import { render, staticRenderFns } from "./case-update-import-details.vue?vue&type=template&id=2f0b6e36&scoped=true"
import script from "./case-update-import-details.vue?vue&type=script&lang=ts"
export * from "./case-update-import-details.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0b6e36",
  null
  
)

export default component.exports